
import { TariffCodeConstant } from "presentation/constant/TariffCode/TariffCodeConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useTariffCodeVM } from "presentation/hook/TariffCode/useTariffCodeVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useTariffCodeTracked } from "presentation/store/TariffCode/TariffCodeProvider";
import FileUpload from "presentation/view/components/FileUpload";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { memo, useCallback, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const TariffCodeTitleBar: React.FC = () => {
    const [tariffCodeState] = useTariffCodeTracked();
    const tariffCodeVM = useTariffCodeVM();
    const messageBarVM = useMessageBarVM();
    const TARIFF_CODE_CONSTANT = TariffCodeConstant.Title;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate, operatingUnit } = anaInfoState;

    const handleAdd = useCallback(() => {
        tariffCodeVM.onAddClick(operatingUnit);
    }, [tariffCodeVM, operatingUnit]);

    const handleUpload = useCallback(async (e: any) => {

        const files = e.target?.files;
        const file = files[0];

        if (!file) {
            return;
        }
        if (file.type !== 'text/csv') {
            messageBarVM.showError('Please upload a .csv file');
            return
        }

        setIsLoading(true);
        await tariffCodeVM.onUpload(file).then(async res => {
            e.target = null;
            if (res.success) {
                await tariffCodeVM.searchTariffCode({}, true).then(data => {
                    setIsLoading(false);
                    messageBarVM.showSuccess("Success!");
                });
            } else {
                setIsLoading(false);
                messageBarVM.showError(res.data);
            }
        });
    }, [messageBarVM, tariffCodeVM]);


    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{TARIFF_CODE_CONSTANT.TARIFF_CODE_MAIN}</HeaderTitle>
        {(tariffCodeState.isLoading || isLoading) && <Loader Indicator="Spinner" size="Medium" />}

        <StyledAction className="tm-animated-wrapper">
            {(allowCreate) && <><NbisIconButton fileName='Icon-add' disabled={false} size='medium' toolTipText={WorkspaceConstant.Common.BUTTON_ADD} onClick={handleAdd} />
                <div className="add-seperator" />
                <FileUpload handleUpload={handleUpload} label={WorkspaceConstant.Common.BUTTON_UPLOAD} theme={"Primary"} accept=".csv" size={"Small"} disabled={false} />
            </>}
        </StyledAction>
    </Sidebarheader>
}

export default memo(TariffCodeTitleBar);